// removed by extract-text-webpack-plugin
module.exports = {"blur70":"app-pages-Customers-Loyalty-Components-Program-ProgramConfiguration-__ProgramConfiguration___uY1P5"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Customers/Loyalty/Components/Program/ProgramConfiguration/ProgramConfiguration.css
// module id = 2078
// module chunks = 0